import { PaginatedRequest } from '../types/api';
import {
  FetchIbanVerificationsResponse,
  FetchIbanVerificationResponse,
  ApproveIbanVerificationRequest,
  RejectIbanVerificationRequest,
  UpdateIbanVerificationStatusResponse,
} from '../types/ibanVerifications';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class IbanVerificationService extends ApiService {
  pathname = 'admin/iban-verification';

  fetchIbanVerifications = async (data: PaginatedRequest) =>
    this.get<FetchIbanVerificationsResponse>(`${this.pathname}?${toQueryParams(data)}`);

  fetchIbanVerification = async (id: number) =>
    this.get<FetchIbanVerificationResponse>(`${this.pathname}/iban-verification/${id}`);

  approveIbanVerification = async (data: ApproveIbanVerificationRequest) => {
    const { id, ...body } = data;
    return this.put<UpdateIbanVerificationStatusResponse, Omit<ApproveIbanVerificationRequest, 'id'>>(
      `${this.pathname}/${id}/status`,
      body,
    );
  };

  rejectIbanVerification = async (data: RejectIbanVerificationRequest) => {
    const { id, ...body } = data;
    return this.put<UpdateIbanVerificationStatusResponse, Omit<RejectIbanVerificationRequest, 'id'>>(
      `${this.pathname}/${id}/status`,
      body,
    );
  };

  getIbanCertificateUrl = (filename: string) =>
    `${process.env.REACT_APP_BASE_API_URL}/${this.pathname}/certificate/${filename}`;

  // Alternative: Fetch certificate as blob if backend requires Bearer token auth
  fetchIbanCertificateBlob = async (filename: string) =>
    this.get<Blob>(`${this.pathname}/media/upload/private/${filename}`, {
      responseType: 'blob',
    });
}

export const ibanVerificationService = new IbanVerificationService();
